import { Outlet, RouteObject } from "react-router-dom";
import LoggedOutRoute from "../containers/LoggedOutRoute/LoggedOutRoute";
import { lazy } from "react";
import BackgroundLayoutWithLogo from "ui/common/components/layout/BackgroundLayoutWithLogo/BackgroundLayoutWithLogo";
import useHideRegisterRoute from "../hooks/useHideRegisterRoute";

export enum AuthRoutes {
    MAIN = "/auth",
    LOGIN = "/auth/login",
    REGISTER = "/auth/register",
    VERIFY_EMAIL = "/auth/verify-email",
    RECOVER_PASSWORD = "/auth/recover-password", // skipcq: SCT-A000
}

const RegisterPage = lazy(() => import("../pages/RegisterPage"));
const LoginPage = lazy(() => import("../pages/LoginPage"));
const VerifyEmailPage = lazy(() => import("../pages/VerifyEmailPage"));
const RecoverPasswordPage = lazy(() => import("../pages/RecoverPasswordPage"));

export const useAuthRoutes = (): RouteObject[] => {
    const hideRegisterRoute = useHideRegisterRoute();

    const registerRoutes: RouteObject[] = hideRegisterRoute
        ? []
        : [
            { path: AuthRoutes.REGISTER, element: <RegisterPage /> },
            { path: AuthRoutes.VERIFY_EMAIL, element: <VerifyEmailPage /> },
        ];

    return [
        {
            path: AuthRoutes.MAIN,
            element: (
                <LoggedOutRoute>
                    <BackgroundLayoutWithLogo>
                        <Outlet />
                    </BackgroundLayoutWithLogo>
                </LoggedOutRoute>
            ),
            children: [
                { path: AuthRoutes.LOGIN, element: <LoginPage /> },
                { path: AuthRoutes.RECOVER_PASSWORD, element: <RecoverPasswordPage /> },
                ...registerRoutes,
            ],
        },
    ];
};
